export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/SylndrLiteStars.cd2b3cbd.svg","height":13,"width":13,"blurWidth":0,"blurHeight":0};